module.exports = __webpack_public_path__ + "static/media/hood-cloak.4de0a23f.svg";